import { Notebook } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getLoginUrl } from "@/lib/api/auth";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";

export function UnauthenticatedState() {
  const loginUrl = getLoginUrl();

  return (
    <Empty className="py-12">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Notebook className="h-16 w-16 text-muted-foreground" />
        </EmptyMedia>
        <EmptyTitle>Notebook</EmptyTitle>
        <EmptyDescription>
          Sign in to start creating and managing your notes
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button asChild>
          <a href={loginUrl}>Sign In</a>
        </Button>
      </EmptyContent>
    </Empty>
  );
}
